(ns minorodata.ai-chat.subs
  (:require [clojure.string]
            [applied-science.js-interop :as js-interop]
            [re-posh.core :as re-posh]
            [re-frame.core :as re-frame]
            ["humanize-duration" :as humanizeDuration]))

(re-frame/reg-sub
 :ai-chat/messages
 (fn [db _]
   (get db :ai-chat-messages)))

(re-frame/reg-sub
 :ai-chat/conversation-id
 (fn [db _]
   (get db :ai-chat-conversation-id)))

(re-frame/reg-sub
 :ai-chat/context
 (fn [db _]
   (get db :ai-chat-context)))

(re-frame/reg-sub
 :ai-chat/loading?
 (fn [db _]
   (get db :ai-chat-loading)))

(re-frame/reg-sub
 :ai-chat/draft
 (fn [db _]
   (get db :ai-chat-draft)))

(re-frame/reg-sub
 :ai-chat/editor-dismissed?
 (fn [db _]
   (boolean (get db :ai-chat-editor-dismissed?))))

(re-frame/reg-sub
 :ai-chat/pending-prompt
 (fn [db _]
   (get db :ai-chat-pending-prompt)))

(re-frame/reg-sub
 :ai-chat/model
 (fn [db _]
   (get db :ai-chat-model)))

(re-frame/reg-sub
 :ai-chat/provider-credentials
 (fn [db _]
   (get db :ai-chat-provider-credentials)))

(re-frame/reg-sub
 :ai-chat/credential-save-result
 (fn [db _]
   (get db :ai-chat-credential-save-result)))

(re-frame/reg-sub
 :ai-chat.sql/editor-context
 :<- [:sql-console-modal.subs/modal-open?]
 (fn [console-open? _]
   (let [route-name @(re-posh/subscribe [:app-route/prop :app-route/name])]
     (cond
       console-open?
       (let [current-tab (or @(re-posh/subscribe [:sql-editor/prop :sql-editor/current-tab]) 0)
             tdc         @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
             tab-data    (nth tdc current-tab {})
             metadata    (:metadata tab-data)
             master-id   (:master-id metadata)
             transform   (when master-id
                           @(re-posh/subscribe [:pipeline-editor.subs/full-transform master-id]))]
         {:sql       (:code tab-data)
          :tab-name  (or (:name transform) (:name metadata) "New statement")
          :master-id master-id
          :group-id  (or (:group-id transform) (:group-id metadata))
          :source    "SQL Console"})

       (= :pipeline-editor route-name)
       (let [target @(re-posh/subscribe [:pipeline-editor.subs/preview-target])]
         (when (= "transform" (:type target))
           (let [master-id (:id target)
                 transform @(re-posh/subscribe [:pipeline-editor.subs/full-transform master-id])
                 unsaved   @(re-posh/subscribe [:pipeline-transform-unsaved/pull
                                                [:pipeline-transform-unsaved/id master-id]])]
             (when (:name transform)
               {:sql       (or (:pipeline-transform-unsaved/command unsaved)
                               (:sql transform)
                               (:command transform))
                :tab-name  (:name transform)
                :master-id master-id
                :group-id  (:group-id transform)
                :source    "Pipeline Editor"}))))))))
